import { Checkbox, Th } from "@chakra-ui/react";

import { Flex } from "@chakra-ui/react";

export function ThCheckbox() {
  return (
    <Th aria-label="Select all" w="36px">
      <Flex justifyContent="center" alignItems="center" h="100%">
        <Checkbox />
      </Flex>
    </Th>
  );
}
